import { render, staticRenderFns } from "./InputFieldNumber.vue?vue&type=template&id=312049f9"
import script from "./InputFieldNumber.vue?vue&type=script&lang=js"
export * from "./InputFieldNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports